import React from 'react';
import cs from 'classnames';

import * as config from '~/misc/countryAndProvince';
import Input from '../Input';
import LabeledInput from '~/components/common/LabeledInput';
import DropDown from '~/components/common/DropDown';
import {MenuList, MenuListItem} from '~/components/common/MenuList';

import css from './index.css';

const BillingInfomation = (props) => (
  <div className={css.formWrap}>
    <form>
      <Input
        mods={['floatLef', 'half']}
        title={'First Name'}
        label={'billFirstname'}
        type='text'
        defaultValue={props.billingInfo.billFirstname}
        fnChange={props.handleChange}
        fnBlur={props.handleBlur}
        error={props.errorControl.billFirstname ? props.errorControl.billFirstname.error : ''}
      />
      <Input
        mods={['floatRigt', 'half']}
        title={'Last Name'}
        label={'billLastname'}
        type='text'
        defaultValue={props.billingInfo.billLastname}
        fnChange={props.handleChange}
        fnBlur={props.handleBlur}
        error={props.errorControl.billLastname ? props.errorControl.billLastname.error : ''}
      />
      <Input
        mods={['floatLef', 'half']}
        title={'Phone'}
        label={'billPhone'}
        type='phone'
        defaultValue={props.billingInfo.billPhone}
        fnChange={props.handleBlur}
        fnBlur={props.handleBlur}
        error={props.errorControl.billPhone ? props.errorControl.billPhone.error : ''}
      />
      <Input
        mods={['floatRigt', 'half']}
        title={'Email'}
        label={'billEmail'}
        type='email'
        defaultValue={props.billingInfo.billEmail}
        fnChange={props.handleChange}
        fnBlur={props.handleBlur}
        error={props.errorControl.billEmail ? props.errorControl.billEmail.error : ''}
      />
      <Input
        mods={['strench', 'floatLef', 'clearFix']}
        title={'Street address'}
        label={'billAddress'}
        type='text'
        defaultValue={props.billingInfo.billAddress}
        fnChange={props.handleChange}
        fnBlur={props.handleBlur}
        error={props.errorControl.billAddress ? props.errorControl.billAddress.error : ''}
      />
      <Input
        mods={['floatLef', 'half']}
        title={'City'}
        label={'billCity'}
        type='text'
        defaultValue={props.billingInfo.billCity}
        fnChange={props.handleChange}
        fnBlur={props.handleBlur}
        error={props.errorControl.billCity ? props.errorControl.billCity.error : ''}
      />
      <DropDown
        data-qa={'bill-sates-dropdown'}
        id={'bill-sates-dropdown'}
        wrapClassName={cs(css.dropdown, css.floatRigt)}
        closeByClick={true}
        contentOverFlowScrolly={true}
        trigger={
          <LabeledInput
            data-qa={'dropdown-compInfo-input'}
            large={true}
            touched={true}
            label='State'
            value={props.billingInfo.billState ? props.billingInfo.billState : ''}
            placeholder={props.billCountry === 'Canada' ? 'Province' : 'State'}
            error={props.errorControl.billState ? props.errorControl.billState.error : ''}
            icon='dropdown'
            tags={false}
            readOnly={true}
            blackLabel='blackLabel'
          />
        }
        content={(
          <div className={cs(css.dropdownContent, css.itemWrap, css.overHid)}>
            <MenuList data-qa={'menu-list-state'}>
              {(props.billingInfo.billCountry && (props.billingInfo.billCountry.toLowerCase() === 'canada'))
                ? config.canadaStates.map((k, num) => (<MenuListItem
                  className={cs('qa-item', `qa-item-${k}`)}
                  key={num + k}
                  name='billState'
                  id={num + k}
                  num={num}
                  selected={Boolean(props.billingInfo.billState && (props.billingInfo.billState === k))}
                  fn={props.handleToggle}
                  title={k}
                />))
                : config.usaStates.map((k, num) => (<MenuListItem
                  className={cs('qa-item', `qa-item-${k}`)}
                  key={num + k}
                  name='billState'
                  id={num + k}
                  num={num}
                  selected={Boolean(props.billingInfo.billState && (props.billingInfo.billState === k))}
                  fn={props.handleToggle}
                  title={k}
                />))
              }
            </MenuList>
          </div>)
        }
      />
      <DropDown
        data-qa={'united-state-dropdown-billInfo'}
        id={'united-state-dropdown-billInfo'}
        wrapClassName={cs(css.dropdown, css.floatLef)}
        closeByClick={true}
        contentOverFlowScrolly={true}
        trigger={
          <LabeledInput
            data-qa={'dropdown-billInfo-input'}
            large={true}
            touched={true}
            label='Country'
            value={props.billingInfo.billCountry ? props.billingInfo.billCountry : 'United States'}
            icon='dropdown'
            tags={false}
            readOnly={true}
            blackLabel='blackLabel'
          />
        }
        content={(
          <div className={cs(css.dropdownContent, css.itemWrap, css.overHid)}>
            <MenuList data-qa={'menu-list-country'}>
              {config.countries.map((k, num) => (<MenuListItem
                className={cs('qa-item', `qa-item-${k}`)}
                key={num + k}
                name='billCountry'
                id={num + k}
                num={num}
                selected={(props.billingInfo.billCountry && (props.billingInfo.billCountry === k)) ? true : null}
                fn={props.handleToggle}
                title={k}
              />))}
            </MenuList>
          </div>)
        }
      />
      <Input
        mods={['floatRigt', 'half']}
        title={'Zip'}
        label={'billZip'}
        type='zip'
        defaultValue={props.billingInfo.billZip}
        fnChange={props.handleBlur}
        fnBlur={props.handleBlur}
        error={props.errorControl.billZip ? props.errorControl.billZip.error : ''}
      />
      {props.needShippingMethod && (<Input
        mods={['floatLef', 'half']}
        title={'Shipping Method'}
        label={'shippingMethod'}
        defaultValue={props.billingInfo.shippingMethod}
        fnChange={props.handleChange}
        fnBlur={props.handleBlur}
        error={props.errorControl.shippingMethod ? props.errorControl.shippingMethod.error : ''}
      />)}
    </form>
  </div>
);

export default BillingInfomation;



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/BillingInfomation/index.js